<div id="footer">
  <div
    class="footer-icon-container"
    *ngIf="isIOS && (backCoordinator.canGoBack$ | async)"
    (click)="back()"
  >
    <div class="footer-icon">
      <img
        [src]="backIconData.iconSrc | safeUrl"
        alt="Back"
        (error)="onImageError()"
      />
    </div>
    <p class="footer-icon-label">{{ backIconData.name }}</p>
  </div>
  <div
    class="footer-icon-container"
    *ngFor="let fi of homeIconData.footerIcons"
    (click)="navigateToFeature(homeIconData.defaultPath, null)"
  >
    <div *ngIf="!isCurrentRouteHome()" class="footer-icon">
      <img [src]="fi.iconSrc | safeUrl" alt="Home" (error)="onImageError()" />
    </div>
    <div *ngIf="isCurrentRouteHome()" class="footer-icon-selected">
      <img
        [src]="fi.negIconSrc | safeUrl"
        alt="Home"
        (error)="onImageError()"
      />
    </div>
    <p class="footer-icon-label">{{ fi.name }}</p>
  </div>
  <ng-container *ngIf="featureBaseUrl">
    <div
      class="footer-icon-container"
      *ngFor="let fi of footerIcons"
      (click)="navigateToFeature(defaultPath, fi.path)"
    >
      <div *ngIf="!doesCurrentRouteMatch(fi.path)" class="footer-icon">
        <img
          [src]="getIcon(fi) | safeUrl"
          [alt]="fi.name"
          (error)="onImageError()"
        />
      </div>
      <div *ngIf="doesCurrentRouteMatch(fi.path)" class="footer-icon-selected">
        <img
          [src]="getNegIcon(fi) | safeUrl"
          [alt]="fi.name"
          (error)="onImageError()"
        />
      </div>
      <p class="footer-icon-label">{{ fi.name }}</p>
    </div>
  </ng-container>
</div>
